<template>
  <!-- 邀请好友 -->
  <div>
    <inviteFriendsComp></inviteFriendsComp>
    <!-- <el-card shadow="never" class="myTeam_card">
      <div slot="header" class="clearfix">
        <div class="desciconLarge"></div>
        <span class="font18">我的邀请</span>
      </div>
      <el-table :data="tableData" :height="tableData && tableData.length > 5 ? '400px' : null" style="width: 100%" :header-cell-style="{background:'#F5F5F5'}">
        <el-table-column prop="inviteDate" align="center" label="邀请日期"></el-table-column>
        <el-table-column prop="clientName" align="center" label="被邀请人"></el-table-column>
        <el-table-column prop="type" align="center" label="邀请类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">海报</span>
            <span v-else-if="scope.row.type === 2">小程序</span>
            <span v-else-if="scope.row.type === 3">链接</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" align="center" label="邀请结果">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1" style="color:#67C23A">成功</span>
            <span v-else-if="scope.row.status == 2" style="color:#F56C6C">失败</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="couponName" align="center" label="优惠券"></el-table-column>
      </el-table>
    </el-card> -->
    <!-- <el-card shadow="never" class="myTeam_card"  style="margin: 30px 0">
      <div slot="header" class="clearfix">
        <div class="desciconLarge"></div>
        <span class="font18">邀请规则</span>
      </div>
      <div>
          <p class="inviteRule">1. 通过分享专属链接、专属邀请二维码、专属邀请海报邀请好友注册纳微创新，即成为你的推荐用户。</p>
          <p class="inviteRule">2. 邀请好友完成注册后实名认证时，被邀请人即可获得纳微创新赠送的优惠券。用户可在纳微创新官网，“个人中心>优惠券”里查看。</p>
          <p class="inviteRule">3. 邀请好友发生首单后，被邀请人即可获得纳微创新赠送的优惠券。用户可在纳微创新官网，“个人中心>优惠券”里查看。</p>
          <p class="inviteRule">4. 邀请的好友越多，获得的优惠券就越多。</p>
      </div>
    </el-card>
    <el-card shadow="never">
      <div slot="header">
        <div class="desciconLarge"></div>
        <span class="font18">邀请方式</span>
      </div>
      <div class="inviteWay">
        <el-row :gutter="40" type="flex" style="flex-wrap: wrap;">
          <el-col :span="8">
            <div class="invite_card">
              <div class="invite_card_left">
                <h3 class="invite_title">链接邀请</h3>
                <div class="font14666" v-if="copyFlag">邀请方式：分享您的专属链接，好友点击链接完成注册</div>
                <div class="font14666" v-else>{{baseUrl}}</div>
              </div>
              <div class="invite_card_right">
                <img style="invite_img" src="../../assets/img/report.png" />
                <div class="invite_right_button" style="width: 60px" @click="copyUrl">生成链接</div>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="invite_card">
              <div class="invite_card_left">
                <h3 class="invite_title">小程序邀请</h3>
                <div class="font14666">邀请方式：微信小程序搜索“纳微创新”，通过“个人>邀请返利”分享给您的好友</div>
              </div>
              <div class="invite_card_right">
                <img style="invite_img" src="../../assets/img/code.png" />
                <div >
                  <el-popover
                    placement="bottom-end"
                    width="350"
                    trigger="click">
                    <div class="codeBox">
                      <div>
                        <img style="width: 150px" :src="QrCode"/>
                      </div>
                      <div>
                        使用微信扫码进入<br/>点击右上角分享好友<br/>完成注册即可确认邀请成功
                        <div class="invite_right_button" style="width: 100px" @click="dowloadImg">下载小程序码</div>
                      </div>
                    </div>
                    <el-button slot="reference" class="invite_right_button">查看二维码</el-button>
                  </el-popover>
                  
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card> -->
    <!-- 查看海报 -->
    <!-- <posterView ref="posterview" v-if="posterVisible"></posterView> -->
  </div>
</template>
<script>
import posterView from "./formPop/posterView"
import { inviteFriends,inviteList } from "@/api/request";
import { getClient } from "@/plugins/auth";
import moment from "moment"
import inviteFriendsComp from "./components/inviteFriendsComp.vue"
export default {
  components: {
    posterView,
    inviteFriendsComp
  },
  data() {
    return {
      QrCode: "",
      posterVisible: false,
      total: 0,
      copyFlag: true,
      baseUrl: '',
      userInfo: JSON.parse(getClient()),
      tableData: []
    };
  },
  mounted () {
    // this.getQrCode()
    // this.getList()
  },
  methods: {
    lookPoster () {
      this.posterVisible = true;
      this.$nextTick(() => {
        this.$refs.posterview.init(1)
      })
    },
    copyUrl(){
      let baseUrl = 'https://www.navi-sci.cn?inviterType=3&aff=' + this.userInfo.clientId
      this.baseUrl = baseUrl
      navigator.clipboard.writeText(baseUrl)
        .then(() => {
            this.$message.success("邀请链接已复制到剪贴板");
        })
        .catch((error) => {
            this.copyFlag = false
            this.$message.warning('复制失败,请手动复制邀请链接');
        });
    },
    getList () {
      inviteList({inviteeId: this.userInfo.clientId}).then(res=> {
        this.tableData = res.rows
        let obj = {
          inviteDate: '合计',
          clientName: res.total || 0,
          type: '-',
          status: '-',
          couponName: '¥'+res.total * 50 || '¥0.00‘'
        }
        this.tableData.push(obj)
        // this.tableData.map(item => {

        // })
      })
    },
    dowloadImg () {
      let nowTime = moment().format('yyyy-MM-DD')
      const filename = `邀请好友-小程序码${nowTime}`
      const img = document.createElement('a')
      img.href = this.QrCode
      img.download = filename
      img.click()
    },
    getQrCode() {
      inviteFriends({width: 100,inviterType: 2}).then(res => {
        let byteData = res.qrCodeBytes
        // 创建图像的 URL
        this.QrCode = 'data:image/png;base64,' + byteData 
    });
    },
  }
};
</script>
<style>
.box-card .el-card__header {
  padding: 0;
  height: 50px;
  line-height: 50px;
}
</style>
<style scoped lang="scss">
.codeBox {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-around;

}
.team_card_right {
  float: right;
  margin-right: 10px;
  line-height: 25px;
  color: #4d6fff;
}
.invite_card {
  display: flex;
  flex-flow: row nowrap;
  height: 150px;
  border-radius: 7px;
  background: #ebf1ff;
  margin: 20px 0;
  padding: 10px 25px;
}
.invite_card_left {
  width: 75%;
}
.invite_right_button {
    cursor: pointer;
    padding: 0 5px;
    height: 20px;
    line-height: 20px;;
    background: #c1cdff;
    font-size: 12px;
    color: #4d6fff;
    text-align: center;
    margin-top: 10px;
    border-radius: 3px;
  }
.invite_card_right {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-left: 8px;
  width: 25%;
  img {
    width: 50%;
  }
  
}
.invite_title {
  margin: 20px 0;
}
.inviteLink {
  width: 95%;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.inviteRule {
    font-size: 15px;
    color: #666;
    padding: 10px;
}
</style>